import { RestClientError } from '../restClient'

// officewave 진입 토큰 발급(loginByEntry) 결과.
// 'success'/'fail' 문자열은 기존 호출자와 하위 호환을 위해 유지하고,
// 409/400 에러는 사용자에게 메시지를 노출하기 위해 객체로 전달한다.
export interface EntryLoginError {
  status: 'error'
  code: number
  message: string
}
export type EntryLoginResult = 'success' | 'fail' | EntryLoginError

// commonAuth 토큰 발급 API 에러를 분류한다.
// 409/400만 응답 message를 사용자에게 노출할 에러 객체로 반환하고, 그 외는 'fail'(기존 동작).
export function classifyEntryError(err: unknown): 'fail' | EntryLoginError {
  if (err instanceof RestClientError && (err.status === 409 || err.status === 400)) {
    return { status: 'error', code: err.status, message: err.message }
  }
  return 'fail'
}
